import { mapDictionaryKey } from "components/Filters/helpers";

import { searchStackRunChangesSuggestionsDictionary } from "../constants";
import { StackRunChangesSuggestions } from "../types";

export const getFilterKey = (key: StackRunChangesSuggestions | string) => {
  return mapDictionaryKey(key, searchStackRunChangesSuggestionsDictionary);
};
